import React from 'react';
import { useNavigate } from 'react-router-dom';
import VirtualTourSection from '../components/VirtualTourSection';

const VirtualTour = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="relative">
        <div className="absolute top-4 left-4 z-10">
          <button
            onClick={handleBack}
            className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/90 hover:bg-white transition-colors shadow-lg"
          >
            <span className="material-symbols-outlined" style={{color: '#C8A96A'}}>
              arrow_back
            </span>
            <span className="font-medium" style={{color: '#3E3E3E'}}>Back to Home</span>
          </button>
        </div>
      </div>

      {/* Full Screen 3D Tour */}
      <VirtualTourSection isModal={true} />
    </div>
  );
};

export default VirtualTour;
